var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"booking-loader d-flex align-center justify-center fill-height",attrs:{"fluid":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":150,"width":11}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }